import { Box, Button, styled } from '@mui/material';

export const ButtonsRow = styled(Box)<{ isPostComment?: boolean }>`
  position: absolute;
  bottom: 18px;
  right: ${({ isPostComment }) => (isPostComment ? '20px' : '132px')};
  display: flex;
  gap: 8px;
  align-items: center;
  @media (max-width: 1023px) {
    bottom: 18px;
    right: 6px;
  }
`;

export const CancelBtn = styled(Button)`
  text-transform: none;
  font-weight: 400;
  @media (max-width: 1023px) {
    font-size: 14px;
    line-height: 16px;
  }
`;

export const SubmitBtn = styled(Button)`
  text-transform: none;
  @media (max-width: 1023px) {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }
`;
